import Alpine from 'alpinejs';

// Accepts a starting state (1..states) so each dynamic image on
// a page can begin on a different clip-path shape — PHP passes it
// in via x-data="imageMorph(N)" using a per-page counter.
Alpine.data('imageMorph', (start = 1) => ({
  states: 3,
  current: start,
  intervalId: null,

  init() {
    this.intervalId = setInterval(() => this.next(), 5000);
  },

  destroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  },

  next() {
    this.current = (this.current % this.states) + 1;
  }
}));
